import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexReactClient } from "convex/react";
import { ThemeProvider } from "next-themes";
import type { ReactNode } from "react";
import { Toaster } from "sonner";
import { AppDataProvider } from "@/data/data-context";
import { FeedbackProvider } from "@/data/feedback-data";
import { InstallationProvider } from "@/components/installation";

const convexUrl = import.meta.env.VITE_CONVEX_URL;
const configured = Boolean(convexUrl) && import.meta.env.VITE_DEMO_MODE !== "true";
const convex = configured ? new ConvexReactClient(convexUrl!) : null;

function InnerProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <InstallationProvider><AppDataProvider configured={configured}><FeedbackProvider>{children}</FeedbackProvider></AppDataProvider></InstallationProvider>
      <Toaster richColors closeButton position="bottom-right" />
    </ThemeProvider>
  );
}

export function Providers({ children }: { children: ReactNode }) {
  if (!convex) return <InnerProviders>{children}</InnerProviders>;
  return <ConvexAuthProvider client={convex}><InnerProviders>{children}</InnerProviders></ConvexAuthProvider>;
}
